// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/weather_actual_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { WeatherForecastPointSelectionState } from "../../bfftypes/v1/weather_forecast_point_selection_state_pb";
import { file_bfftypes_v1_weather_forecast_point_selection_state } from "../../bfftypes/v1/weather_forecast_point_selection_state_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/weather_actual_model.proto.
 */
export const file_bffuser_v1_weather_actual_model: GenFile = /*@__PURE__*/
  fileDesc("CiViZmZ1c2VyL3YxL3dlYXRoZXJfYWN0dWFsX21vZGVsLnByb3RvEgpiZmZ1c2VyLnYxIt8CChFBcmVhV2VhdGhlckFjdHVhbBIoCglhcmVhX2NvZGUYASABKA4yFS5iZmZ0eXBlcy52MS5BcmVhQ29kZRIbChNyZXNvbHZlZF9wb2ludF9uYW1lGAIgASgJEhQKDGlzX2F2YWlsYWJsZRgEIAEoCBI7ChJsYXRlc3Rfb2JzZXJ2ZWRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSACIAQESLgoGcG9pbnRzGAYgAygLMh4uYmZmdXNlci52MS5XZWF0aGVyQWN0dWFsUG9pbnQSTgoVcG9pbnRfc2VsZWN0aW9uX3N0YXRlGAcgASgOMi8uYmZmdHlwZXMudjEuV2VhdGhlckZvcmVjYXN0UG9pbnRTZWxlY3Rpb25TdGF0ZUIVChNfbGF0ZXN0X29ic2VydmVkX2F0SgQIAxAEUhNpc19kZWZhdWx0X2ZhbGxiYWNrIsACChJXZWF0aGVyQWN0dWFsUG9pbnQSMwoPdGFyZ2V0X2RhdGV0aW1lGAEgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgt0ZW1wZXJhdHVyZRgCIAEoCzIULmdvb2dsZS50eXBlLkRlY2ltYWxIAIgBARIsCglkZXdfcG9pbnQYAyABKAsyFC5nb29nbGUudHlwZS5EZWNpbWFsSAGIAQESMAoNcHJlY2lwaXRhdGlvbhgEIAEoCzIULmdvb2dsZS50eXBlLkRlY2ltYWxIAogBARI1Cgljb25kaXRpb24YBSABKA4yIi5iZmZ1c2VyLnYxLldlYXRoZXJBY3R1YWxDb25kaXRpb25CDgoMX3RlbXBlcmF0dXJlQgwKCl9kZXdfcG9pbnRCEAoOX3ByZWNpcGl0YXRpb24q0QEKFldlYXRoZXJBY3R1YWxDb25kaXRpb24SKAokV0VBVEhFUl9BQ1RVQUxfQ09ORElUSU9OX1VOU1BFQ0lGSUVEEAASIgoeV0VBVEhFUl9BQ1RVQUxfQ09ORElUSU9OX1NVTk5ZEAESIwofV0VBVEhFUl9BQ1RVQUxfQ09ORElUSU9OX0NMT1VEWRACEiEKHVdFQVRIRVJfQUNUVUFMX0NPTkRJVElPTl9SQUlOEAMSIQodV0VBVEhFUl9BQ1RVQUxfQ09ORElUSU9OX1NOT1cQBEJAWj5naXRodWIuY29tL2VuZWNoYWluL2ViYWxhbmNlL2dvL2dlbi9wcm90by9iZmZ1c2VyL3YxO2JmZnVzZXJ2MWIGcHJvdG8z", [file_bfftypes_v1_area, file_bfftypes_v1_weather_forecast_point_selection_state, file_google_protobuf_timestamp, file_google_type_decimal]);

/**
 * AreaWeatherActual mirrors internalapi.v1.AreaWeatherActual for the frontend:
 * the observed-weather bundle (JMA AMeDAS 10-minute readings aggregated to the
 * 30-minute koma grid) for one electricity area.
 *
 * @generated from message bffuser.v1.AreaWeatherActual
 */
export type AreaWeatherActual = Message<"bffuser.v1.AreaWeatherActual"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * Resolved point display name (e.g. "札幌"). Empty when is_available=false.
   *
   * @generated from field: string resolved_point_name = 2;
   */
  resolvedPointName: string;

  /**
   * False when the resolved point has no AMeDAS station mapping (今後実装予定);
   * points is then empty.
   *
   * @generated from field: bool is_available = 4;
   */
  isAvailable: boolean;

  /**
   * The newest observation datetime seen in range. Absent when unavailable or
   * when no observation exists in range.
   *
   * @generated from field: optional google.protobuf.Timestamp latest_observed_at = 5;
   */
  latestObservedAt?: Timestamp;

  /**
   * 30-minute koma points, ascending by target_datetime. Komas without any
   * observation in range are omitted (sparse).
   *
   * @generated from field: repeated bffuser.v1.WeatherActualPoint points = 6;
   */
  points: WeatherActualPoint[];

  /**
   * Why the point behind resolved_point_name was chosen (明示選択 / 未設定で
   * 既定 / 失効で既定). Replaces the retired is_default_fallback bool.
   *
   * @generated from field: bfftypes.v1.WeatherForecastPointSelectionState point_selection_state = 7;
   */
  pointSelectionState: WeatherForecastPointSelectionState;
};

/**
 * Describes the message bffuser.v1.AreaWeatherActual.
 * Use `create(AreaWeatherActualSchema)` to create a new message.
 */
export const AreaWeatherActualSchema: GenMessage<AreaWeatherActual> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_actual_model, 0);

/**
 * WeatherActualPoint is the aggregate of the AMeDAS 10-minute observations
 * within one 30-minute koma.
 *
 * @generated from message bffuser.v1.WeatherActualPoint
 */
export type WeatherActualPoint = Message<"bffuser.v1.WeatherActualPoint"> & {
  /**
   * Koma start instant (JST koma grid).
   *
   * @generated from field: google.protobuf.Timestamp target_datetime = 1;
   */
  targetDatetime?: Timestamp;

  /**
   * Temperature observed at the koma start (:00 / :30) (℃, rounded to 0.1;
   * not averaged). Absent when the koma-start reading or its temperature is
   * missing.
   *
   * @generated from field: optional google.type.Decimal temperature = 2;
   */
  temperature?: Decimal;

  /**
   * Dew point (℃, rounded to 0.1; Magnus-Tetens from the koma-start temperature
   * and humidity). Absent when either input is missing.
   *
   * @generated from field: optional google.type.Decimal dew_point = 3;
   */
  dewPoint?: Decimal;

  /**
   * Total precipitation over the koma (mm, sum of 10-minute readings).
   *
   * @generated from field: optional google.type.Decimal precipitation = 4;
   */
  precipitation?: Decimal;

  /**
   * Observed weather condition derived from sunshine/precipitation readings.
   * UNSPECIFIED when underivable (e.g. nighttime with no precipitation).
   *
   * @generated from field: bffuser.v1.WeatherActualCondition condition = 5;
   */
  condition: WeatherActualCondition;
};

/**
 * Describes the message bffuser.v1.WeatherActualPoint.
 * Use `create(WeatherActualPointSchema)` to create a new message.
 */
export const WeatherActualPointSchema: GenMessage<WeatherActualPoint> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_actual_model, 1);

/**
 * WeatherActualCondition is the coarse observed-weather class (wire values
 * mirror internalapi.v1.WeatherActualCondition).
 *
 * @generated from enum bffuser.v1.WeatherActualCondition
 */
export enum WeatherActualCondition {
  /**
   * @generated from enum value: WEATHER_ACTUAL_CONDITION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WEATHER_ACTUAL_CONDITION_SUNNY = 1;
   */
  SUNNY = 1,

  /**
   * @generated from enum value: WEATHER_ACTUAL_CONDITION_CLOUDY = 2;
   */
  CLOUDY = 2,

  /**
   * @generated from enum value: WEATHER_ACTUAL_CONDITION_RAIN = 3;
   */
  RAIN = 3,

  /**
   * @generated from enum value: WEATHER_ACTUAL_CONDITION_SNOW = 4;
   */
  SNOW = 4,
}

/**
 * Describes the enum bffuser.v1.WeatherActualCondition.
 */
export const WeatherActualConditionSchema: GenEnum<WeatherActualCondition> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_weather_actual_model, 0);

